
'use strict';

import analytics from '../../../src/js/shared/analytics';
import cf7Helpers from '../../../src/js/shared/cf7Helpers';
import sliders from '../../../src/js/shared/sliders';
import utmTracking from '../../../src/js/shared/utmTracking';
import flatpickr from 'flatpickr';

const $ = jQuery.noConflict();

$(function() {
	const MOBILE_BREAKPOINT = 768;

	const sliderConfig = {
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: false,
		autoplay: false,
		infinite: false,
		dots: true,
		speed: 500,
		rows: 0,
		responsive: [],
	};

	const booking = {
		selectedUnitType: '',
		selectedFloorPlan: '',

		init: function() {
			this.cacheDOM();
			this.bindEvents();
			this.initFromUrl();
			if (this.$form.length) {
				utmTracking.applyToForm(this.$form);
			}
			this.initDatepicker();
			const $activeBtn = this.$unitBtns.filter('.is-active').first();
			if ($activeBtn.length) {
				this.selectedUnitType = $activeBtn.data('label') || '';
				this.maybeInitSlider($activeBtn.data('unit'));
			}
			this.initCalendly();
			cf7Helpers.scrollToFirstError('.js-booking', 120);
			this.initSubmitState();
			this.syncSourceOther();
		},

		cacheDOM: function() {
			this.$section = $('.js-booking');
			this.$unitBtns = $('.js-booking-unit');
			this.$unitHidden = this.$section.find('input[name="unit-type"]');
			this.$planHidden = this.$section.find('input[name="floor-plan"]');
			this.$planError = this.$section.find('.js-booking-plan-error');
			this.$form = this.$section.find('.wpcf7-form');
			this.$calendly = this.$section.find('.js-booking-calendly');
			this.$sourceSelect = this.$section.find('select[name="lead-source"]');
			this.$sourceOtherWrap = this.$section.find('.js-booking-source-other');
			this.$sourceOtherInput = this.$sourceOtherWrap.find('input[name="lead-source-other"]');
			this.$sourceError = this.$section.find('.js-booking-source-error');
		},

		bindEvents: function() {
			this.$unitBtns.on('click', this.handleUnitSelect.bind(this));
			this.$section.on('click', '.js-booking-plan-btn', this.handlePlanSelect.bind(this));
			if (this.$form.length && (this.$planError.length || this.$sourceOtherWrap.length)) {
				this.$form[0].addEventListener('submit', this.handleFormSubmit.bind(this), true);
			}
			this.$sourceSelect.on('change', this.syncSourceOther.bind(this));
			this.$sourceOtherInput.on('input', this.handleSourceOtherInput.bind(this));
			document.addEventListener('wpcf7mailsent', this.handleLeadSubmitted.bind(this), false);
		},

		handleFormSubmit: function(e) {
			if (this.$planError.length && !this.$planHidden.val()) {
				e.preventDefault();
				e.stopPropagation();
				this.$planError.addClass('is-visible');
				const $visiblePlans = this.$section.find('.js-booking-plans:not(.is-hidden)');
				const $target = $visiblePlans.length ? $visiblePlans : this.$planError;
				$('html, body').animate({scrollTop: $target.offset().top - 120}, 300);
				return;
			}

			if (this.$sourceOtherWrap.length && this.$sourceSelect.val() === 'Other' && !this.$sourceOtherInput.val().trim()) {
				e.preventDefault();
				e.stopPropagation();
				this.$sourceError.addClass('is-visible');
				$('html, body').animate({scrollTop: this.$sourceOtherWrap.offset().top - 120}, 300);
			}
		},

		syncSourceOther: function() {
			if (!this.$sourceSelect.length || !this.$sourceOtherWrap.length) {
				return;
			}
			const isOther = this.$sourceSelect.val() === 'Other';

			this.$sourceOtherWrap.toggleClass('is-hidden', !isOther);
			this.$sourceOtherInput.prop('disabled', !isOther).prop('required', isOther);

			if (!isOther) {
				this.$sourceOtherInput.val('');
				this.$sourceError.removeClass('is-visible');
			}
		},

		handleSourceOtherInput: function() {
			if (this.$sourceOtherInput.val().trim()) {
				this.$sourceError.removeClass('is-visible');
			}
		},

		handleUnitSelect: function(e) {
			const $btn = $(e.currentTarget);
			const unit = $btn.data('unit');
			const label = $btn.data('label');
			const $prevBtn = this.$unitBtns.filter('.is-active').first();
			const prevUnit = $prevBtn.length ? $prevBtn.data('unit') : null;

			this.$unitBtns.removeClass('is-active');
			$btn.addClass('is-active');
			this.$unitHidden.val(label);
			this.$planHidden.val('');
			this.$planError.removeClass('is-visible');

			this.selectedUnitType = label || '';
			this.selectedFloorPlan = '';

			this.$section.find('.js-booking-plan').removeClass('is-active');
			this.$section.find('.js-booking-plan-btn').text('SELECT LAYOUT');

			if (prevUnit && $(window).width() < MOBILE_BREAKPOINT) {
				this.destroySlider(prevUnit);
			}

			if (prevUnit) {
				this.$section.find(`.js-booking-plans[data-unit="${prevUnit}"]`).addClass('is-hidden');
			}
			this.$section.find(`.js-booking-plans[data-unit="${unit}"]`).removeClass('is-hidden');

			this.maybeInitSlider(unit);
		},

		handlePlanSelect: function(e) {
			const $btn = $(e.currentTarget);
			const $card = $btn.closest('.js-booking-plan');
			const $slider = $card.closest('.booking__plans-slider');

			$slider.find('.js-booking-plan').removeClass('is-active');
			$slider.find('.js-booking-plan-btn').text('SELECT LAYOUT');
			$card.addClass('is-active');
			$btn.text('SELECTED');

			this.$planHidden.val($card.data('plan'));
			this.$planError.removeClass('is-visible');

			this.selectedFloorPlan = $card.data('plan-title') || '';

			/* eslint-disable camelcase -- param names must match the registered GA4 event dimensions */
			analytics.trackEvent('apartment_selected', {
				unit_type: this.selectedUnitType,
				floor_plan: this.selectedFloorPlan,
			});
			/* eslint-enable camelcase */
		},

		handleLeadSubmitted: function(e) {
			if (!this.$section.length || !this.$section[0].contains(e.target)) {
				return;
			}

			/* eslint-disable camelcase -- param names must match the registered GA4 event dimensions */
			analytics.trackEvent('generate_lead', {
				unit_type: this.selectedUnitType,
				floor_plan: this.selectedFloorPlan,
				cta_location: this.$section.data('cta-location') || '',
				currency: 'USD',
				value: 1,
			});
			/* eslint-enable camelcase */
		},

		maybeInitSlider: function(unit) {
			if ($(window).width() >= MOBILE_BREAKPOINT) {
				return;
			}
			const selector = `.js-booking-slider--${unit}`;
			if ($(selector).length && !$(selector).hasClass('slick-initialized')) {
				sliders.initializeSlider(selector, sliderConfig);
			}
		},

		destroySlider: function(unit) {
			const $slider = $(`.js-booking-slider--${unit}`);
			if ($slider.hasClass('slick-initialized')) {
				$slider.slick('unslick');
			}
		},

		initFromUrl: function() {
			const params = new URLSearchParams(window.location.search);
			const unit = params.get('unit');
			if (!unit) {
				return;
			}
			const $btn = this.$unitBtns.filter(`[data-unit="${unit}"]`);
			if ($btn.length) {
				$btn.trigger('click');
			}
		},

		initDatepicker: function() {
			const targets = document.querySelectorAll('.js-booking-date-picker');
			if (!targets.length) {
				return;
			}
			targets.forEach((el) => {
				flatpickr(el, {
					dateFormat: 'm/d/Y',
					disableMobile: true,
				});
			});
		},

		initCalendly: function() {
			if (!this.$calendly.length) {
				return;
			}

			const baseUrl = this.$section.data('calendly-url');
			if (!baseUrl) {
				return;
			}

			document.addEventListener('wpcf7mailsent', (e) => {
				const inputs = e.detail.inputs || [];
				const getValue = (keyword) => {
					const field = inputs.find((f) => f.name.toLowerCase().includes(keyword));
					return field ? field.value.trim() : '';
				};

				const firstName = getValue('first');
				const lastName = getValue('last');
				const email = getValue('email');
				const phone = getValue('phone');
				const moveInDate = getValue('tour-date');
				const currentEmployer = getValue('current-employer');
				const householdIncome = getValue('household-income');
				const fullName = [firstName, lastName].filter(Boolean).join(' ');

				const unitType = this.$unitHidden.val() || '';
				const floorPlan = this.$planHidden.val() || '';

				const params = new URLSearchParams({
					'hide_event_type_details': '1',
					'hide_gdpr_banner': '1',
				});
				if (fullName) params.set('name', fullName);
				if (email) params.set('email', email);
				if (unitType) params.set('a1', unitType);
				if (floorPlan) params.set('a2', floorPlan);
				if (phone) params.set('a3', phone);
				if (moveInDate) params.set('a4', moveInDate);
				if (currentEmployer) params.set('a5', currentEmployer);
				if (householdIncome) params.set('a6', householdIncome);

				const utmFields = utmTracking.getFields();
				if (utmFields['utm-source']) params.set('utm_source', utmFields['utm-source']);
				if (utmFields['utm-medium']) params.set('utm_medium', utmFields['utm-medium']);
				if (utmFields['utm-campaign']) params.set('utm_campaign', utmFields['utm-campaign']);
				if (utmFields['utm-content']) params.set('utm_content', utmFields['utm-content']);
				if (utmFields['utm-term']) params.set('utm_term', utmFields['utm-term']);

				const iframe = document.createElement('iframe');
				iframe.src = `${baseUrl}?${params.toString()}`;
				iframe.title = 'Schedule your tour';
				iframe.width = '100%';
				iframe.setAttribute('frameborder', '0');

				this.$calendly[0].appendChild(iframe);
				this.$calendly.attr('aria-hidden', 'false');
				this.$section.addClass('calendly-is-shown');

				const top = this.$calendly.offset().top - 120;
				$('html, body').animate({scrollTop: top}, 600);
			}, false);
		},

		initSubmitState: function() {
			const holder = document.querySelector('.js-booking');
			if (!holder) {
				return;
			}

			const getSubmit = () => holder.querySelector('.wpcf7-submit');

			document.addEventListener('wpcf7beforesubmit', () => {
				const btn = getSubmit();
				if (btn) {
					btn.disabled = true;
				}
			}, false);

			const enableSubmit = () => {
				const btn = getSubmit();
				if (btn) {
					btn.disabled = false;
				}
			};

			document.addEventListener('wpcf7mailsent', enableSubmit, false);
			document.addEventListener('wpcf7invalid', enableSubmit, false);
			document.addEventListener('wpcf7mailfailed', enableSubmit, false);
			document.addEventListener('wpcf7spam', enableSubmit, false);
		},
	};

	booking.init();
});
